<div class="tp-page">
  <tp-page-header
    title="Tasas de interés"
    subtitle="Tasa del precio de lista y planes de cuotas para las cotizaciones"
  ></tp-page-header>

  <form class="tp-card tp-form" [formGroup]="listPriceForm">
    <fieldset class="tp-form__section">
      <legend class="tp-form__section-title">Tasa para cálculo de precio de lista</legend>
      <div class="tp-form__grid">
        <div class="tp-form__field">
          <label class="tp-form__label" for="list-price-rate">Tasa del precio de lista</label>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              id="list-price-rate"
              matInput
              placeholder=""
              formControlName="values"
              type="number"
              (keydown)="validateOnlyNumbers($event)"
              (input)="validateTwoDecimals($event)"
            />
            @if (listPriceForm.controls.values.hasError('required')) {
              <mat-error>Ingresá la tasa.</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </fieldset>
    <div class="tp-form__actions">
      <button mat-flat-button [disabled]="listPriceForm.invalid" (click)="updateListPriceRate()">
        Actualizar
      </button>
    </div>
  </form>

  <form class="tp-card tp-form" [formGroup]="interestForm">
    <fieldset class="tp-form__section">
      <legend class="tp-form__section-title">Actualización de interés por cuota</legend>
      <div class="tp-form__grid">
        <div class="tp-form__field tp-form__field--full">
          <label class="tp-form__label" for="plan-description">Nombre del plan</label>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              id="plan-description"
              matInput
              placeholder="Nombre del plan"
              formControlName="description"
            />@if (interestForm.controls.description.hasError('required')) {
              <mat-error>El nombre del plan es obligatorio.</mat-error>
            } @else if (interestForm.controls.description.hasError('maxlength')) {
              <mat-error>El nombre del plan no puede superar los 25 caracteres.</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="tp-form__field">
          <label class="tp-form__label" for="plan-interest">Interés %</label>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              id="plan-interest"
              matInput
              type="number"
              class="number"
              placeholder="Interés %"
              formControlName="interestRate"
              (keydown)="validateOnlyNumbers($event)"
              (keyup)="validateTwoDecimals($event)"
            />
          </mat-form-field>
        </div>
        <div class="tp-form__field">
          <label class="tp-form__label" for="plan-installments">Cantidad de cuotas</label>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              id="plan-installments"
              matInput
              type="number"
              placeholder="Cantidad de cuotas"
              formControlName="installments"
              (keydown)="validateOnlyTowNumbers($event)"
            />@if (interestForm.controls.installments.hasError('required')) {
              <mat-error>La cantidad de cuotas es obligatoria.</mat-error>
            } @else if (interestForm.controls.installments.hasError('min')) {
              <mat-error>La cantidad de cuotas debe ser mayor a 0.</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </fieldset>
    <div class="tp-form__actions">
      <button mat-flat-button (click)="onSubmit()">
        Guardar
      </button>
    </div>
  </form>

  <section class="tp-card tp-card--flush">
    <h2 class="tp-card__title ir-table-title">Tasas de interés</h2>
    <div class="tp-table-responsive">
      <table class="table mb-0">
        <thead>
          <tr>
            <th scope="col">Plan</th>
            <th scope="col">Interés %</th>
            <th scope="col">Cuotas</th>
            <th scope="col">Activo/Inactivo</th>
            <th scope="col" class="text-end">Eliminar</th>
          </tr>
        </thead>
        <tbody>
          @for (item of currentInterestRate; track item) {
            <tr>
              <td class="editable" (click)="editPlan(item.id)">
                {{ item.description }}
              </td>
              <td>{{ item.interestRate }}</td>
              <td>{{ item.installments }}</td>
              <td>
                <button
                  type="button"
                  class="btn-status"
                  [ngClass]="item.isActive ? 'btn-on' : 'btn-off'"
                  (click)="activateDeactivate(item)"
                >
                  {{ item.isActive ? "Activo" : "Inactivo" }}
                </button>
              </td>
              <td class="text-end">
                <button
                  mat-icon-button
                  type="button"
                  aria-label="Eliminar plan"
                  title="Eliminar plan"
                  (click)="deletePlan(item.id)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="5">
                <tp-empty-state
                  icon="percent"
                  title="Todavía no hay planes de cuotas"
                  message="Cargá un plan con el formulario de arriba."
                ></tp-empty-state>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </section>
</div>
